export const twoFactorType = {
    none: 0,
    email: 1,
    sms: 2,
    securityquestions: 3,
    googleauthenticator: 4
};
